import {dispatch} from "react-use-event/src/use-event.ts";

export type HighLightAddressSearchEvent = {
    type: "HighLightAddressSearchEvent"
    show: boolean
}

export function DispatchHighLightAddressSearchEvent(show: boolean) {
    return dispatch('HighLightAddressSearchEvent', {show: show})
}

export type ResetErrorReportPageEvent = {
    type: "ResetErrorReportPageEvent"
}

export function DispatchResetErrorReportPageEvent() {
    return dispatch('ResetErrorReportPageEvent', {})
}
